import React, { useEffect, useState } from "react";
import { DataEntryField } from "./DataEntryField";
import { UnitOfMeasureControl } from "../controls/UnitOfMeasureControl";
import {
  DistanceControl,
  DistanceFieldChangeResult
} from "../controls/DistanceControl";
import { Distance, UnitOfMeasure } from "../../pace-fns/pace-fns";
import {isDistanceValid} from "../../calculator.utility";

type Props = {
  distance: Distance;
  onChange(isValid: boolean, distance?: Distance): void;
  selectField: () => void;
  isCalculable: boolean;
};

export const DistanceEntryField = ({
  distance,
  selectField,
  isCalculable,
  onChange
}: Props) => {
  const [distanceState, setDistanceState] = useState(distance);
  const onUnitOfMeasureControlChange = (unitOfMeasure: UnitOfMeasure) => {
    const updatedDistanceState: Distance = { ...distanceState, unitOfMeasure };
    setDistanceState(updatedDistanceState);
    onChange(isDistanceValid(updatedDistanceState), updatedDistanceState);
  };

  const onDistanceControlChange = (changeResult: DistanceFieldChangeResult) => {
    setDistanceState(changeResult.data.value!);
    onChange(changeResult.valid, changeResult.data.value);
  };

  useEffect(() => {
    setDistanceState(distance);
  }, [distance]);

  const DistanceEntryField = (
    <DistanceControl
      onChange={onDistanceControlChange}
      distance={distanceState}
    ></DistanceControl>
  );

  const UnitOfMeasureEntryField = (
    <UnitOfMeasureControl
      onChange={onUnitOfMeasureControlChange}
      value={
        (distanceState && distanceState.unitOfMeasure) || UnitOfMeasure.METER
      }
    />
  );

  return (
    <DataEntryField
      fields={[DistanceEntryField, UnitOfMeasureEntryField]}
      isCalculable={isCalculable}
      onSelect={selectField}
    ></DataEntryField>
  );
};
